module.exports = __webpack_public_path__ + "static/media/construccion_tex.4a6a63ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/construction/construccion_tex.png
// module id = 138
// module chunks = 0